const DEFAULT_API_BASE_URL = 'https://api-legacy.construrapi.cloud';

const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (!configuredBaseUrl) {
    return DEFAULT_API_BASE_URL;
  }

  return configuredBaseUrl.replace(/\/+$/, '');
};

export const API_BASE_URL = getApiBaseUrl();
export const API_GRAPHQL_URL = `${API_BASE_URL}/graphql`;
